import EventClass from "common/utils/ui/event-class";
import ModalClass from "common/utils/ui/modal-class";
import DesignUploadCtaPLPFileUploadClass from "./design-upload-cta-plp-file-upload-class";
import DesignUploadCtaPlpLibraryUploadClass from "./design-upload-cta-plp-library-upload-class";
import DesignUploadCtaPlpDropzoneClass from "./design-upload-cta-plp-dropzone-class";
import DesignUploadCtaPlpFileRemoveClass from "./design-upload-cta-plp-file-remove-class";

export default class DesignUploadCtaPlpClass {
  #fileUploadHandler;

  #libraryUploadHandler;

  #fileWindowHandler;

  #dropzoneHandler;

  #fileRemoveHandler;

  #modal;

  #modalToggleHandler;

  #canvaToggleHandler;

  // eslint-disable-next-line max-lines-per-function
  constructor(props) {
    this.#modal = new ModalClass({
      modalSelector: props.designModalSelector
    });

    this.#modalToggleHandler = new EventClass({
      eventSelector: props.designModalToggle,
      eventCallback: () => this.#modal.openModal()
    });

    this.#canvaToggleHandler = new EventClass({
      eventSelector: props.canvaUploadSelector,
      eventCallback: () => this.#modal.closeModal()
    });

    this.#fileUploadHandler = new DesignUploadCtaPLPFileUploadClass({
      eventSelector: props.fileUploadInputSelector,
      event: "change",
      dtfChannel: props.dtfChannel
    });

    this.#fileWindowHandler = new EventClass({
      eventSelector: props.fileUploadSelector,
      eventCallback: () => {
        this.#fileUploadHandler.emulateClick();
        this.#modal.closeModal();
      }
    });

    this.#libraryUploadHandler = new DesignUploadCtaPlpLibraryUploadClass({
      eventSelector: props.libraryUploadSelector,
      event: "click",
      state: {
        businessLine: "Print",
        catalogNumber: "DTF001",
        singleSelectionMode: true,
        pdpType: "non-pdp"
      },
      eventCallback: () => this.#modal.closeModal()
    });

    this.#dropzoneHandler = new DesignUploadCtaPlpDropzoneClass({
      eventSelector: props.dropzoneSelector,
      event: "drop",
      dtfChannel: props.dtfChannel
    });

    this.#fileRemoveHandler = new DesignUploadCtaPlpFileRemoveClass({
      eventSelector: props.removeDesignSelector
    });
  }

  init() {
    this.#dropzoneHandler.init();
  }
}
